module.exports = __webpack_public_path__ + "img/vu.d5792c67.svg";